import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@app/components/cleanui/system/Guard/auth.guard';
import { PrivacyGuard } from '@app/components/cleanui/system/Guard/privacy.guard';
import { profilePages } from '@app/pages/profile/profile.routes';
import { ProfileComponent } from '@app/pages/profile/profile/profile.component';
import { SharedModule } from '@app/shared.module';
import { FormsModule } from '@angular/forms';
import { ElementsModule } from '@app/components/elements/elements.module';
import { JsonSchemaRendererModule } from '@app/components/renderer/json-schema-renderer.modul';


@NgModule({
	declarations: [
		ProfileComponent
	],
	imports: [
		CommonModule,
		SharedModule,
		FormsModule,
		ElementsModule,
		JsonSchemaRendererModule,
		RouterModule.forChild([
			{
				path: profilePages.root.url,
				component: ProfileComponent,
				canActivate: [AuthGuard, PrivacyGuard],
				data: {
					title: 'person.user',
				}
			},
		])
	],
})
export class ProfileModule {}
